















































































































































































import Vue from 'vue';
import Component from 'vue-class-component';
import { Watch } from 'vue-property-decorator';
import { ClientGroupService } from '../../service/ClientGroupService';
import { ClientGroupDropdownDto } from '../../models/client/ClientGroupDropdownDto';
import { ClientService } from '../../service/ClientService';
import { DataGrid } from '@questelservices/common-vue';
import {
  DxColumn,
  DxEditing,
  DxForm,
  DxFormItem,
  DxHeaderFilter,
  DxLookup,
  DxPopup,
  DxStateStoring
} from 'devextreme-vue/data-grid';
import { DxItem, DxGroupItem, DxButtonItem } from 'devextreme-vue/form';
import { DxDropDownBox, DxSelectBox, DxButton, DxTextBox, DxCheckBox } from 'devextreme-vue';
import DevExpress from 'devextreme/bundles/dx.all';
import CustomStore from 'devextreme/data/custom_store';
import { QuestelServicesClient } from '@questelservices/common';
import { Dictionary } from 'vue-router/types/router';
import _ from 'lodash';

@Component({
  components: {
    DxDropDownBox,
    DxSelectBox,
    DataGrid,
    DxColumn,
    DxEditing,
    DxForm,
    DxFormItem,
    DxHeaderFilter,
    DxItem,
    DxGroupItem,
    DxButtonItem,
    DxLookup,
    DxPopup,
    DxStateStoring,
    DxButton,
    DxTextBox,
    DxCheckBox
  }
})
export default class ClientGroupDataGrid extends Vue {
  clients: Array<{ text: string; value: Guid }> = [];
  selectedClient: Guid = '';
  dataGrid: any;
  clientGroupDataCustomStoreOptions: DevExpress.data.CustomStoreOptions;
  clientGroupService: ClientGroupService = new ClientGroupService();
  dropdownData: Map<string, Array<string>> = new Map<string, Array<string>>();

  constructor() {
    super();
    this.loadData();
    this.clientGroupDataCustomStoreOptions = {
      key: 'ClientGroupId',
      load: loadOptions => this.clientGroupService.search(loadOptions).catch(this.handleResponseError),
      insert: values => this.clientGroupService.create(values).catch(this.handleResponseError),
      update: (key, values) => this.clientGroupService.edit(key, values).catch(this.handleResponseError),
      remove: key => this.clientGroupService.delete(key).catch(this.handleResponseError)
    };
  }

  @Watch('selectedClient')
  onSelectedClientChange() {    
    this.refreshDropdownData();    
  }

  async loadData() {    
    let clientService = new ClientService();
    let clients = await clientService.getAll();
    this.clients = clients.map(c => {
      return { text: c.ClientName, value: c.ClientId };
    });     
  }

  handleResponseError(result: any) {
    let message = 'An unknown error occurred.';
    if (result && result.Message) {
      message = result.Message;

      let index = message.indexOf(' (Error');
      if (index > -1) {
        message = message.substring(0, index);
      }
    }

    throw Error(message);
  }

  async refreshDropdownData() {
    if (this.selectedClient) {
      this.dropdownData = (await this.clientGroupService.getDropdownData(this.selectedClient)).DropdownData;   
    }    
  }

  popupShowing(e: any) {
    // Couldn't find a configuration option for this, so changing the style of Save and Cancel when loading the dialog.
    var toolbarItems = e.component.option('toolbarItems');
    toolbarItems[0].options.stylingMode = 'contained';
    toolbarItems[1].options.stylingMode = 'contained';
    toolbarItems[1].options.type = 'normal';
    e.component.option('toolbarItems', toolbarItems);
  }

  initNewRow(e: any) {        
    e.data = {
      ClientId: this.selectedClient
    };
  }

  editingStart(e: any) {
    if (!e.data.ClientId) {
      e.data.ClientId = '';
    }
  }

  rowUpdating(e: any) {
    // Add back any data not edited
    e.newData = _.merge({}, e.oldData, e.newData);
  }

  dataGridInitialized(e: any): void {
    this.dataGrid = e.component;
  }

  saveEditData(): void {
    if (this.dataGrid) {
      this.dataGrid.focus();
      this.dataGrid.saveEditData();
    }
  }
}
